var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "m13.568 12.816-1.08-4.084 3.287-2.724-4.226-.234-1.55-3.944L8.45 5.774l-4.273.234 3.334 2.724-1.08 4.084 3.568-2.3 3.569 2.3Zm4.46-4.789c0 .533.196 1.002.587 1.409.391.406.853.61 1.385.61v3.99c0 .532-.196 1.001-.587 1.408-.391.407-.853.61-1.385.61H1.972c-.532 0-.994-.203-1.385-.61S0 14.568 0 14.036v-3.99c.564 0 1.033-.196 1.408-.587.375-.392.563-.869.564-1.433 0-.532-.196-1.001-.587-1.408-.391-.406-.853-.61-1.385-.61v-3.99C0 1.486.196 1.017.587.61.978.203 1.44 0 1.972 0h16.056c.532 0 .994.203 1.385.61S20 1.486 20 2.018v3.99c-.532 0-.994.204-1.385.61-.391.407-.587.876-.587 1.408v.001Z",
    fill: "white"
  })));
};
export default SvgTicket;